import { render, staticRenderFns } from "./Over18.vue?vue&type=template&id=053761eb&scoped=true&"
import script from "./Over18.vue?vue&type=script&lang=js&"
export * from "./Over18.vue?vue&type=script&lang=js&"
import style0 from "./Over18.vue?vue&type=style&index=0&id=053761eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053761eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
